import {combineReducers} from 'redux'

import languageReducer from './languageReducer'
import portfolioReducer from './portfolioReducer'
import leadsFormReducer from './leadsFormReducer'
import trackerReducer from './trackerReducer'
import authReducer from './authReducer'

const rootReducer = combineReducers({
  languageReducer,
  portfolioReducer,
  leadsFormReducer,
  trackerReducer,
  authReducer,
})

export default rootReducer
